// Contact.jsx
import React from 'react';

const Contact = () => {
  return (
    <div>
      <h2>Contact Page</h2>
      <p>Contact us at contact@example.com</p>
    </div>
  );
};

export default Contact;
